module.exports = __webpack_public_path__ + "img/ic_kc-logo.649d21a4.svg";